import { useAppTranslation } from '@hooks';
import { useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { Divider } from 'antd';
import {
  Button,
  FormItem,
  SelectOption,
  SelectInput,
  Form,
} from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';

const statuses = ['lastDay', 'last7Days', 'lastMonth', 'lastYear'] as const;

const drawerContentStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const fullWidthStyle = css`
  width: 100%;
`;

type FiltersContributorPropsType = {
  visible: boolean
  onClose: () => void
};

const FiltersContributor = ({ visible, onClose }: FiltersContributorPropsType) => {
  const { translate } = useAppTranslation();
  const { register, handleSubmit } = useForm();

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form
        onFinish={handleSubmit((data) => {
          onClose();
          return data;
        })}
        css={drawerContentStyle}
      >
        {/* Добавитьеще отдельный компонент */}
        <FormItem label={translate('common.date')}>
          <SelectInput {...register('date')} css={fullWidthStyle}>
            {statuses.map((i) => (
              <SelectOption key={i} value={i}>
                {translate(`contributor.periods.${i}`)}
              </SelectOption>
            ))}
          </SelectInput>
        </FormItem>

        {/* <FormItem label="Projet">
					<SearchPanel showItems={false} title={""} />
				</FormItem>

				<FormItem label="Segment">
					<SearchPanel showItems={false} title={""} />
				</FormItem>

				<FormItem label="Typologie">
					<SearchPanel showItems={false} title={""} />
				</FormItem> */}

        <Divider
          css={css`
            margin-top: 35vh;
          `}
        />

        <FiltersDrawerFooter>
          <Button onClick={onClose}>{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

export default FiltersContributor;
